import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../../../components/global/modal/withModal';
import Button from '../../../../../../../../../components/global/Button';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    picture_day_enabled: PropTypes.bool,
    has_charity: PropTypes.bool,
    charity_description: PropTypes.string,
  }),
  onViewPhotos: PropTypes.func,
};

const CHARITY_NOTICE_MODAL = 'modal/CHARITY_NOTICE_MODAL';

const Notice = ({ albumFolder, onViewPhotos }) => {
  return (
    <Fragment>
      <h4 className="text-center">Great news!</h4>
      <p className="text-center mt-4">
        Your school will be providing you with {albumFolder.charity_description}
        !
        <br />
        <br />
        You can view all your photos and purchase additional prints and packages
        by tapping &apos;View my Photos&apos; below.
      </p>
      <div className="text-center mt-2">
        <Button btnOutline onClick={onViewPhotos}>
          View my Photos
        </Button>
      </div>
    </Fragment>
  );
};

Notice.propTypes = propTypes;

export { Notice };

export default withModal(Notice, {
  name: CHARITY_NOTICE_MODAL,
  size: 'sm',
  type: 'full',
  dismissible: false,
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  overlayClassName: 'charity-notice-modal',
});
